
<v-tooltip top class="help-tooltip">
  <template v-slot:activator="{ on }">
    <v-icon v-on="on" class="helpIcon" :class="{'tooltip-icon-inline': inline}">
      help_outline
    </v-icon>
  </template>
  <span><slot/></span>
</v-tooltip>
